import { REQUEST_REGISTRATION_DATA, RECEIVE_REGISTRATION_DATA, IRegistrationState, RegistrationDataTypes } from "./types";

const initialState: IRegistrationState = {
    registrationData: { personalInfo: {}, addressInfo: {}, billingInfo: {}, PaymentMode: {}, securityInfo: {}, twoFactorMFA: {}, NotificationPreference: {} },
    isLoading: false,
};

export function registrationDataReducer(state = initialState, action: RegistrationDataTypes): IRegistrationState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_REGISTRATION_DATA:
            return {
                isLoading: true,
                registrationData: state.registrationData,
            };
        case RECEIVE_REGISTRATION_DATA:
            return {
                isLoading: false,
                registrationData: action.registrationData,
            };
        default:
            return state;
    }
}
